import { types, initState } from "./types";

const getKpi = (state = initState, action) => {
  switch (action.type) {
    case types.REFRESH_KPIS:
      /* eslint-disable */
      return {
        ...state,
        historicKpis: null,
        monthRef: null,
        isLoading:
          action.payload && action.payload.isLoading === false ? false : true,
      };
    case types.GET_KPI_SCORE_SUCCESS:
      return {
        ...state,
        groupKpis: action.groupKpis,
        groupAllKpis: action.groupAllKpis,
        draftKpis: action.draftKpis,
        companyKpis: action.companyKpis,
        usersKpis: action.usersKpis,
        myKpis: action.myKpis,
        adminKpis: action.adminKpis,
        isLoading: false,
        monthRef: null, // Reset to Present month
        error: null,
      };
    case types.GET_KPI_SCORE_EMPTY:
      return {
        ...state,
        groupKpis: [],
        groupAllKpis: [],
        companyKpis: [],
        usersKpis: [],
        myKpis: null,
        adminKpis: null,
        isLoading: false,
        monthRef: null, // Reset to Present month
        error: "No KPIs",
      };
    case types.GET_KPI_SCORE_FAILED:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case types.KPI_FETCH_SKIPPED:
      return {
        ...state,
        isLoading: false,
      };
    case types.GET_PREVIOUS_KPIS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case types.GET_PREVIOUS_KPIS_SUCCESS:
      return {
        ...state,
        historicKpis: { ...state.historicKpis, ...action.historicKpis },
        monthRef: action.monthRef,
        isLoading: false,
      };
    case types.GET_PREVIOUS_KPIS_FAILED:
      return {
        ...state,
        isLoading: false,
      };
    case types.SET_TO_LIVE_KPIS:
      // Removes monthRef to disable historic data
      return {
        ...state,
        monthRef: null,
      };
    case types.SET_TO_HISTORIC_KPIS:
      return {
        ...state,
        isLoading: false,
        monthRef: action.monthRef,
      };
    case types.ADD_USER_KPI_REQUEST:
    case types.UPDATE_USER_KPI_REQUEST:
    case types.DELETE_USER_KPI_REQUEST:
      return {
        ...state,
        error: null,
      };
    case types.ADD_OLD_USER_KPI_SUCCESS:
    case types.ADD_USER_KPI_SUCCESS:
      return {
        ...state,
        usersKpis: action.usersKpis,
        myKpis: action.myKpis,
      };
    case types.ADD_USER_KPI_FAILED:
    case types.ADD_OLD_USER_KPI_FAILED:
    case types.UPDATE_USER_KPI_FAILED:
    case types.DELETE_USER_KPI_FAILED:
      return {
        ...state,
        error: action.message || action,
      };
    case types.ADD_PAST_MONTH_KPI_SUCCESS: {
      const { monthKey, userId, kpiId, amount, points } = action;
      const prevMonthUsers = state.historicKpis?.[monthKey];
      // If month data isn't loaded yet, skip the optimistic update rather than overwriting with []
      if (!Array.isArray(prevMonthUsers)) return state;
      const updatedMonthUsers = prevMonthUsers.map((user) => {
        if (String(user.userId) !== String(userId)) return user;
        const prev = user.month[kpiId] ?? { pts: 0, amt: 0 };
        return {
          ...user,
          month: {
            ...user.month,
            [kpiId]: { pts: prev.pts + points, amt: prev.amt + amount },
            total: (user.month.total ?? 0) + points,
          },
        };
      });
      return {
        ...state,
        historicKpis: {
          ...state.historicKpis,
          [monthKey]: updatedMonthUsers,
        },
      };
    }
    case types.SET_PAST_MONTH_KPI_TOTAL_SUCCESS: {
      // Replace (not add) amt/pts for Scorekeeper total-score edits on a past month.
      const { monthKey, userId, kpiId, amount, points } = action;
      const prevMonthUsers = state.historicKpis?.[monthKey];
      if (!Array.isArray(prevMonthUsers)) return state;
      let found = false;
      const updatedMonthUsers = prevMonthUsers.map((user) => {
        if (String(user.userId) !== String(userId)) return user;
        found = true;
        const prevPts = user.month?.[kpiId]?.pts ?? 0;
        return {
          ...user,
          month: {
            ...user.month,
            [kpiId]: { pts: points, amt: amount },
            total: (user.month.total ?? 0) - prevPts + points,
          },
        };
      });
      if (!found) {
        updatedMonthUsers.push({
          userId,
          month: { [kpiId]: { pts: points, amt: amount }, total: points },
        });
      }
      return {
        ...state,
        historicKpis: {
          ...state.historicKpis,
          [monthKey]: updatedMonthUsers,
        },
      };
    }
    case types.UPDATE_MY_KPIS:
      return {
        ...state,
        myKpis: action.myKpis,
      };
    case types.UPDATE_ADMIN_KPIS:
      return {
        ...state,
        adminKpis: action.adminKpis,
      };
    case types.UPDATE_MONTH_KPIS:
      return {
        ...state,
        usersKpis: action.usersKpis,
      };
    default:
      return state;
  }
};

export default getKpi;